module.exports = __webpack_public_path__ + "img/num03.11ca2d96.png";